module.exports = __webpack_public_path__ + "../resources/images/letsgo-stars-b-8988d157fcf0a144db0c7c48182e8a4a.png";